import { render } from "./MBaseModal.vue?vue&type=template&id=a3c0ca1e&scoped=true&ts=true"
import script from "./MBaseModal.vue?vue&type=script&lang=ts"
export * from "./MBaseModal.vue?vue&type=script&lang=ts"

import "./MBaseModal.vue?vue&type=style&index=0&id=a3c0ca1e&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3c0ca1e"]])

export default __exports__